module.exports = __webpack_public_path__ + "static/img/responsibilitybg.d1d298d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/responsibilitybg.jpg
// module id = J4qn
// module chunks = 1